import { safeSessionStorage } from "@/lib/safeStorage";

const PORTAL_SESSION_KEY = "simpler_portal_slug";

const PORTAL_SLUG_PATTERN =
  /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;


export function normalizePortalSlug(value) {
  const slug = String(value || "")
    .trim()
    .toLowerCase();

  if (!slug || slug.length > 63) {
    return null;
  }

  return PORTAL_SLUG_PATTERN.test(slug)
    ? slug
    : null;
}


function isDevelopmentOrPreviewHost(hostname) {
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.endsWith(".preview.emergentagent.com") ||
    hostname.endsWith(".emergentagent.com")
  );
}


function portalSlugFromPath() {
  if (typeof window === "undefined") {
    return null;
  }

  /*
   * Produção:
   *
   * /portal/57903578000175
   */
  const match = window.location.pathname.match(
    /^\/portal\/([^/?#]+)\/?$/i
  );

  if (!match) {
    return null;
  }

  try {
    return normalizePortalSlug(
      decodeURIComponent(match[1])
    );
  } catch {
    return null;
  }
}


export function getPortalSlug() {
  if (typeof window === "undefined") {
    return null;
  }

  const hostname =
    window.location.hostname.toLowerCase();

  const params =
    new URLSearchParams(window.location.search);


  /*
   * Compatibilidade para preview/testes:
   *
   * /login?portal=57903578000175
   */
  const queryPortal = normalizePortalSlug(
    params.get("portal") ||
      params.get("portal_slug")
  );

  if (queryPortal) {
    safeSessionStorage.setItem(
      PORTAL_SESSION_KEY,
      queryPortal
    );

    return queryPortal;
  }


  /*
   * NOVO PADRÃO OFICIAL:
   *
   * simplersolucoes.com.br/portal/57903578000175
   */
  const pathPortal = portalSlugFromPath();

  if (pathPortal) {
    safeSessionStorage.setItem(
      PORTAL_SESSION_KEY,
      pathPortal
    );

    return pathPortal;
  }


  /*
   * Compatibilidade com o padrão antigo.
   * Pode ser removida futuramente depois da migração.
   *
   * 57903578000175.portal.simplersolucoes.com.br
   */
  const hostnameMatch = hostname.match(
    /^([a-z0-9-]+)\.portal\./
  );

  if (hostnameMatch) {
    const hostnamePortal =
      normalizePortalSlug(
        hostnameMatch[1]
      );

    if (hostnamePortal) {
      safeSessionStorage.setItem(
        PORTAL_SESSION_KEY,
        hostnamePortal
      );

      return hostnamePortal;
    }
  }


  /*
   * Depois que o usuário entra por /portal/CNPJ,
   * mantemos o tenant durante a navegação para /app.
   *
   * sessionStorage é isolado por aba do navegador.
   */
  const sessionPortal =
    normalizePortalSlug(
      safeSessionStorage.getItem(
        PORTAL_SESSION_KEY
      )
    );

  if (sessionPortal) {
    return sessionPortal;
  }


  /*
   * Mantém explicitamente a compatibilidade
   * com ambientes da Emergent.
   */
  if (isDevelopmentOrPreviewHost(hostname)) {
    return normalizePortalSlug(
      safeSessionStorage.getItem(
        PORTAL_SESSION_KEY
      )
    );
  }

  return null;
}


export function clearPreviewPortal() {
  if (typeof window !== "undefined") {
    safeSessionStorage.removeItem(
      PORTAL_SESSION_KEY
    );
  }
}
